import type { PlantPolicy, PlantPolicyPatch } from '../types/domain.types';

import { CTL_ENDPOINTS } from './endpoints';
import { request } from './http';
import { parseOrThrow, plantPolicySchema } from './schemas';

export const fetchPlantPolicy = async (plantId: string, signal: AbortSignal | undefined): Promise<PlantPolicy> => {
  const raw = await request('get', CTL_ENDPOINTS.PLANT_POLICY(plantId), { signal });
  return parseOrThrow(plantPolicySchema, raw, 'plant policy');
};

export const updatePlantPolicy = async (plantId: string, patch: PlantPolicyPatch): Promise<PlantPolicy> => {
  const raw = await request('patch', CTL_ENDPOINTS.PLANT_POLICY(plantId), { body: patch });
  return parseOrThrow(plantPolicySchema, raw, 'plant policy');
};
